import { Reveal } from "@/components/Reveal";
import { PROCESS_STEPS } from "@/data/content";

export const ProcessSteps = ({ compact = false }) => (
  <ol data-testid="process-steps" className={`grid gap-5 ${compact ? "md:grid-cols-3 lg:grid-cols-6" : "md:grid-cols-2 lg:grid-cols-3"}`}>
    {PROCESS_STEPS.map((s, i) => (
      <Reveal key={s.step} delay={i * 0.05} className="h-full">
        <li data-testid={`process-step-${i + 1}`} className={`card card-hover flex h-full flex-col ${compact ? "p-5" : "p-7"}`}>
          <span className={`inline-flex items-center justify-center rounded-lg bg-brand-soft font-display font-bold text-brand ${compact ? "h-9 w-9 text-sm" : "h-11 w-11 text-base"}`}>{s.step}</span>
          <h3 className={`mt-4 font-display font-semibold tracking-tight ${compact ? "text-base" : "text-lg"}`}>{s.title}</h3>
          <p className={`mt-2 leading-relaxed text-slate-600 ${compact ? "text-xs" : "text-sm"}`}>{compact ? `${s.text.split(".")[0]}.` : s.text}</p>
        </li>
      </Reveal>
    ))}
  </ol>
);
